<template>
  <section>
    <div class="max-w-3xl mx-auto px-4 sm:px-6">
      <div class="pb-12 md:pb-20">

        <!-- Section header -->
        <h3 class="h4 mb-8">Open positions</h3>

        <!-- Job list -->
        <div class="-my-3" data-aos-id-career>

          <!-- 1st Item -->
          <div class="py-3" data-aos="fade-up" data-aos-anchor="[data-aos-id-career]">
            <div class="pb-6 border-b border-gray-800">
              <div class="mb-2">
                <a class="flex justify-between items-center text-xl font-bold text-purple-600 hover:text-gray-200 transition duration-150 ease-in-out" href="#0">
                  <span>Lead Product Designer</span>
                  <svg class="stroke-current flex-shrink-0 ml-2" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <g stroke-width="2" fill="none">
                      <path d="M1 12h20" />
                      <path stroke-linecap="square" d="M14 5l7 7-7 7" />
                    </g>
                  </svg>
                </a>
              </div>
              <div class="text-lg text-gray-400 mb-3">
                You'll be joing the Experience Design Team as a Lead Product Designer. You'll interface daily with developers - encouraging and advancing best practices in software.
              </div>
              <div class="text-gray-400 flex flex-wrap items-center">
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="17" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                  </svg>
                  <span>Anywhere (EU timezone)</span>
                </div>
                <span class="text-gray-700 mx-3"> - </span>
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M9.5 3L11 0H3l1.5 3zM10 5H4c-2 1.458-4 4.235-4 6.4C0 12.573.5 16 7 16c6.495 0 7-3.431 7-4.6 0-2.165-2-4.942-4-6.4z" />
                  </svg>
                  <span>$70k – $120k</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 2nd Item -->
          <div class="py-3" data-aos="fade-up" data-aos-delay="200" data-aos-anchor="[data-aos-id-career]">
            <div class="pb-6 border-b border-gray-800">
              <div class="mb-2">
                <a class="flex justify-between items-center text-xl font-bold text-purple-600 hover:text-gray-200 transition duration-150 ease-in-out" href="#0">
                  <span>Front-end Engineer</span>
                  <svg class="stroke-current flex-shrink-0 ml-2" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <g stroke-width="2" fill="none">
                      <path d="M1 12h20" />
                      <path stroke-linecap="square" d="M14 5l7 7-7 7" />
                    </g>
                  </svg>
                </a>
              </div>
              <div class="text-lg text-gray-400 mb-3">
                You'll be joing the Experience Design Team as a Lead Product Designer. You'll interface daily with developers - encouraging and advancing best practices in software.
              </div>
              <div class="text-gray-400 flex flex-wrap items-center">
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="17" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                  </svg>
                  <span>Anywhere (EU timezone)</span>
                </div>
                <span class="text-gray-700 mx-3"> - </span>
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M9.5 3L11 0H3l1.5 3zM10 5H4c-2 1.458-4 4.235-4 6.4C0 12.573.5 16 7 16c6.495 0 7-3.431 7-4.6 0-2.165-2-4.942-4-6.4z" />
                  </svg>
                  <span>$70k – $120k</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 3rd Item -->
          <div class="py-3" data-aos="fade-up" data-aos-delay="400" data-aos-anchor="[data-aos-id-career]">
            <div class="pb-6 border-b border-gray-800">
              <div class="mb-2">
                <a class="flex justify-between items-center text-xl font-bold text-purple-600 hover:text-gray-200 transition duration-150 ease-in-out" href="#0">
                  <span>Product Manager</span>
                  <svg class="stroke-current flex-shrink-0 ml-2" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <g stroke-width="2" fill="none">
                      <path d="M1 12h20" />
                      <path stroke-linecap="square" d="M14 5l7 7-7 7" />
                    </g>
                  </svg>
                </a>
              </div>
              <div class="text-lg text-gray-400 mb-3">
                You'll be joing the Experience Design Team as a Lead Product Designer. You'll interface daily with developers - encouraging and advancing best practices in software.
              </div>
              <div class="text-gray-400 flex flex-wrap items-center">
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="17" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                  </svg>
                  <span>Anywhere (EU timezone)</span>
                </div>
                <span class="text-gray-700 mx-3"> - </span>
                <div class="inline-flex items-center">
                  <svg class="mr-2 flex-shrink-0" vidth="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-current text-gray-300" d="M9.5 3L11 0H3l1.5 3zM10 5H4c-2 1.458-4 4.235-4 6.4C0 12.573.5 16 7 16c6.495 0 7-3.431 7-4.6 0-2.165-2-4.942-4-6.4z" />
                  </svg>
                  <span>$70k – $120k</span>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Career'
}
</script>